import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import pb from '../lib/pocketbase';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(pb.authStore.model || null);
  const [isValid, setIsValid] = useState(pb.authStore.isValid);
  const isAdmin = useMemo(() => (user?.role === 'admin'), [user]);

  useEffect(() => {
    const unsub = pb.authStore.onChange(() => {
      setUser(pb.authStore.model || null);
      setIsValid(pb.authStore.isValid);
    });
    return () => {
      if (unsub) unsub();
    };
  }, []);

  const login = async (email, password) => {
    await pb.collection('users').authWithPassword(email, password);
  };

  const register = async ({ email, password, passwordConfirm, name }) => {
    await pb.collection('users').create({ email, password, passwordConfirm, name });
    // Optionally auto-login after register
    await pb.collection('users').authWithPassword(email, password);
  };

  const resetPassword = async (email) => {
    await pb.collection('users').requestPasswordReset(email);
  };

  const logout = () => {
    pb.authStore.clear();
    setUser(null);
    setIsValid(false);
  };

  const value = {
    pb,
    user,
    isValid,
    isAuthenticated: isValid && !!user,
    isAdmin,
    login,
    register,
    resetPassword,
    logout,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}
